import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Coupon from './index';
import MobileCoupon from './MobileCoupon';

const ResponsiveCoupon = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileCoupon />}
      desktop={<Coupon />}
    />
  );
};

export default ResponsiveCoupon;